import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../project/reusableComponents/AccordianForTeams';
import { RenderHeader } from '.';
import { validateStringValue } from '../../../../utils/common';


const Detail = ({ label, value }) => {
    if (!value) return <></>;
    return (
        <p className='w-full flex  gap-4 font-normal'>
            <span className={'capitalize text-font11 text-scogogray'}>{label}</span> <span>{value}</span>
        </p>
    );
};

export const RenderPartnerDetails = ({ user, expanded, handleChange }) => {
    return <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} elevation={0}>
        <AccordionSummary expandIcon={<span className='material-icons text-scogobgsky'> expand_more </span>} aria-controls='panel1bh-content' id='panel1bh-header'>
            <RenderHeader title="Partner Details" is_verified={user.is_verified} />
        </AccordionSummary>
        <AccordionDetails>
            <div className='gap-3 flex flex-col text-font11 px-6'>
                <Detail label='Name' value={`${validateStringValue(user.full_name)}`} />
                <Detail label='Email' value={`${validateStringValue(user.email)}`} />
                <Detail label='Mobile' value={`${validateStringValue(user.mobile)}`} />
                <Detail label='Address' value={`${validateStringValue(user?.address?.user_input)}`} />
                <p className='flex items-center gap-4 font-normal'>
                    <span className={'capitalize text-font11 text-scogogray'}>Roles</span>
                    {user.roles && user.roles.map(({ role }) => {
                        return <p className='bg-tagbg max-w-max truncate scogoprimary text-font10 px-p-6 py-p-3 flex items-center erounded-3px mr-2 mb-1 font-medium'>{role.label}</p>
                    })}
                </p>

            </div>
        </AccordionDetails>
    </Accordion>;
};